import {Component, DestroyRef, inject, signal} from '@angular/core';
import {takeUntilDestroyed} from '@angular/core/rxjs-interop';
import {DatePipe} from '@angular/common';
import {RouterLink} from '@angular/router';
import {NzButtonModule} from 'ng-zorro-antd/button';
import {NzCardModule} from 'ng-zorro-antd/card';
import {TranslatePipe} from '@ngx-translate/core';
import {AuthFlowService, MyConsent} from '../../core/services/auth-flow.service';
import {ConsentView} from '../../shared/consent-view/consent-view';

@Component({
  selector: 'app-account-privacy-policy',
  standalone: true,
  imports: [
    ConsentView,
    DatePipe,
    RouterLink,
    NzButtonModule,
    NzCardModule,
    TranslatePipe,
  ],
  templateUrl: './account-privacy-policy.html',
  styleUrl: './account-privacy-policy.css',
})
export class AccountPrivacyPolicy {
  private readonly authFlow = inject(AuthFlowService);
  private readonly destroyRef = inject(DestroyRef);

  readonly consent = signal<MyConsent | null>(null);

  constructor() {
    this.authFlow.myConsent()
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(consent => this.consent.set(consent));
  }
}
